import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { APIList } from 'src/interfaces'
import { Entities } from 'src/enums'
import { ContractorTransfer } from 'src/api'
import { useApiInstance } from './useApiInstance'
import { buildRequestParams, ObjectType, transformPage, transformPerPage } from './helpers'

interface AdminContractorTransfersGetParams {
  contractorId: number
  limit: number
  offset: number
  sort: string
}

interface RequestParams {
  params?: Partial<AdminContractorTransfersGetParams>
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>
  options?: Omit<UseQueryOptions<APIList<ContractorTransfer>, Error>, 'queryKey' | 'queryFn'>
}

const schema: ObjectType['schema'] = {
  contractorId: 'number',
  limit: 'number',
  offset: 'number',
  sort: 'string'
}

export const useContractorTransferListRequest = ({ params = {}, paramsTransform = [], options }: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [transformPerPage, transformPage, ...paramsTransform].reduce((param, transform) => transform(param), params)

  const queryParams = buildRequestParams<Partial<AdminContractorTransfersGetParams>>(transformedParams, schema)

  return useQuery<APIList<ContractorTransfer>, Error>(
    [Entities.ContractorTransfers, JSON.stringify(transformedParams)],
    async () => {
      const { contractorId, limit, offset, sort } = queryParams
      const { data } = await api.v1AdminContractorTransfersGet(contractorId, limit, offset, sort)
      return data as unknown as APIList<ContractorTransfer>
    },
    {
      enabled: Object.keys(transformedParams).length > 0,
      ...options
    }
  )
}
